import api from '../baseApi.js'
import { byName, unwrap } from '../helpers.js'

export const subjectsApi = {
  getAll: () => api.get('/subjects').then(unwrap).then(byName),
  getByClass: (classId) => api.get(`/subjects/${classId}`).then(unwrap).then(byName),
  create: (data) => api.post('/subjects/create', data).then(unwrap),
  update: (id, data) => api.put(`/subjects/${id}`, data).then(unwrap),
  remove: (id) => api.delete(`/subjects/${id}`).then(unwrap),
  assignTeachers: (id, data) => api.put(`/subjects/${id}/teachers`, data).then(unwrap),
}
